import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import { computed, onMounted, ref, watch } from "vue";
import InputSearch from "@/components/ui/input/InputSearch.vue";
import SwitchComponent from "@/components/ui/SwitchComponent.vue";
import {
  customerNavigation,
  logOutCustomerNavigation,
} from "@/static/navigation";
import { useStore } from "vuex";
import { isLogged, getUser } from "@/features/useUser";
import { getFirstLetter } from "@/helpers/transformation/string";
import DropDown from "@/components/ui/dropdown/DropDown.vue";
import { useRoute } from "vue-router";
import { EstateInterface } from "@/types/EstateInterface";
import { getEoiLogoUrl } from "@/helpers/eoi/getEoiLogoUrl";

interface Props {
  estate?: EstateInterface,
  hideAuthButtons?: boolean,
  overAll?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderCustomer',
  props: {
    estate: {},
    hideAuthButtons: { type: Boolean },
    overAll: { type: Boolean }
  },
  emits: ["login", "register", "interest", "contact"],
  setup(__props: any, { expose: __expose, emit: emits }) {
  __expose();

const props = __props;

const route = useRoute();

const store = useStore();



const search = ref("");
const navigationKey = ref(0);
const activeNavItem = ref({});
const getNormalizedNavigation = computed(() => {
  return customerNavigation.filter((item) => item.slug !== "profile");
});
const showMobileMenu = ref(false);

const businessId = computed(() => {
  return router.currentRoute.value.query?.businessId as string ?? null;
})

const logoUrl = computed(() => {
  if(!props.estate) return ''
  return getEoiLogoUrl(props.estate, businessId.value)
});

watch(route, (value) => {
  if (value.name === "CustomerProfile") {
    activeNavItem.value = {};
    navigationKey.value += 1;
  } else {
    setNavItem();
  }
});
watch(
  () => showMobileMenu.value,
  (value) => {
    if (value) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }
);
function onChangeNavidationItem(value) {
  router.push(value.link);
}
function setNavItem() {
  const activeItem = customerNavigation.find((item) =>
    router.currentRoute.value.path.includes(item.link)
  );
  if (activeItem) {
    activeNavItem.value = activeItem;
  }
}
function onProfile() {
  activeNavItem.value = {};
  navigationKey.value += 1;
  router.push("/customer/profile");
}
function onMyAccount() {
  router.push({ name: "Customer" });
}
const onLogout = () => {
  store.dispatch("user/logout").then(() => {
    if (router.currentRoute.value.name !== "EstateMap") {
      router.push("/");
    }
  });
};
function onLogo() {
  router.push({ name: "CustomerLots" });
  activeNavItem.value = customerNavigation.find((item) => item.slug == "lots");
}
function handleLogOutUserMenu(emitName: any) {
  emits(emitName);
  showMobileMenu.value = false;
}
onMounted(() => {
  setNavItem();
});

const __returned__ = { route, store, props, emits, search, navigationKey, activeNavItem, getNormalizedNavigation, showMobileMenu, businessId, logoUrl, onChangeNavidationItem, setNavItem, onProfile, onMyAccount, onLogout, onLogo, handleLogOutUserMenu, get router() { return router }, computed, onMounted, ref, watch, InputSearch, SwitchComponent, get customerNavigation() { return customerNavigation }, get logOutCustomerNavigation() { return logOutCustomerNavigation }, get useStore() { return useStore }, get isLogged() { return isLogged }, get getUser() { return getUser }, get getFirstLetter() { return getFirstLetter }, DropDown, get useRoute() { return useRoute }, get EstateInterface() { return EstateInterface }, get getEoiLogoUrl() { return getEoiLogoUrl } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})